import { apiRequest } from "./client";

export async function fetchTodo(todoPublicId) {
  const response = await apiRequest(`/api/v1/todos/${todoPublicId}`);
  return response.json();
}

export async function updateTask(todoPublicId, taskPublicId, updatedData) {
  const response = await apiRequest(
    `/api/v1/todos/${todoPublicId}/tasks/${taskPublicId}`,
    {
      method: "PATCH",
      body: JSON.stringify(updatedData),
    }
  );
  return response.json();
}
